import { defineStore } from 'pinia';

export const useCommonStore = defineStore('common', {
  state: () => ({
    checkedList: [] // list check - 페이지 이동 시 초기화 router -> beforeEach
  }),
  getters: {},
  actions: {
    checkedReset() {
      this.checkedList = [];
    }
  }
});
